<template>
	<b-modal :title="__('translations.title.report_issue')" id="report-issue-modal" centered
		:hide-footer="true"
		:no-close-on-backdrop="true">
		<form @submit.prevent="save">
			<div v-if="artifact.type === 'page'" class="form-group row">
				<label for="title" class="col-sm-4 col-form-label col-form-label-sm pr-0">{{ __('translations.notebook') }}</label>
				<div class="col-sm-8">
					<input type="text" class="form-control form-control-sm" name="document_name" id="document_name" disabled :value="artifact.document.document_name"/>
				</div>
			</div>
			<div class="form-group row">
				<label v-if="artifact.type === 'image'" for="title" class="col-sm-4 col-form-label col-form-label-sm pr-0">{{ __('translations.label.image_id') }}</label>
				<label v-else for="title" class="col-sm-4 col-form-label col-form-label-sm pr-0">{{ __('translations.label.page_num') }}</label>
				<div class="col-sm-8">
					<input type="text" class="form-control form-control-sm" name="artifact_id" id="artifact_id" disabled :value="imageIdOrPageNum"/>
				</div>
			</div>
				
			<div class="form-group row">
				<label for="issue_type" class="col-sm-4 col-form-label col-form-label-sm pr-0">{{ __('translations.label.issue_type') }}</label>
				<div class="col-sm-8">
					<select class="form-control form-control-sm" name="issue_type" v-model="issue_type">
				      <option value=""></option>
				      <option value="rotation">{{ __('translations.issue_type.rotation') }}</option>
				      <option value="duplicate">{{ __('translations.issue_type.duplicate') }}</option>
				      <option value="quality">{{ __('translations.issue_type.quality') }}</option>
				      <option value="other">{{ __('translations.issue_type.other') }}</option>
				    </select>
				    <div v-if="errors && errors.issue_type" class="text-danger"><small>{{ errors.issue_type[0] }}</small></div>
				</div>
			</div>
			
			<div class="form-group row">
				<label for="issue_detail" class="col-sm-4 col-form-label col-form-label-sm pr-0">{{ __('translations.label.issue_detail') }}</label>
				<div class="col-sm-8">
					<textarea class="form-control form-control-sm" rows="3" name="issue_detail" v-model="issue_detail" style="resize: none;" />
					<div v-if="errors && errors.issue_detail" class="text-danger"><small>{{ errors.issue_detail[0] }}</small></div>
				</div>
			</div>
			
			<div class="row">
				<label class="col-sm-4 pr-0"></label>
				<div class="col-sm-8">
					<button type="submit" class="btn btn-sm btn-success">{{ __('translations.button.submit') }}</button>
					<button type="button" class="btn btn-sm btn-secondary ml-2" @click="resetData(); hide();">{{ __('translations.button.cancel') }}</button>
				</div>
			</div>
		</form>
    </b-modal>
</template>

<script>
import FormMixin from '../mixins/FormMixin';

export default {
	name: 'ReportIssueForm',
	mixins: [FormMixin],
	props: ['artifact'],
	data() {
		return {
			issue_type: '',
			issue_detail: '',
			action: '/reportIssue',
	    }
	},
	computed: {
		imageIdOrPageNum() {
			return (this.artifact.type === 'image') ? this.artifact.image_id : this.artifact.page + 1;
		}
	},
	watch: {
		success: function(newValue, oldValue) {
			if(newValue) {
				this.hide();
				this.$bvModal.msgBoxOk(this.__('translations.message.issue_submitted'), {
					buttonSize: 'sm',
					footerClass: 'py-1 d-flex justify-content-center',
					okTitle: this.__('translations.button.ok'),
					centered: true,
					noCloseOnBackdrop: true,
				}).then(value => {
					this.$emit('reported', this.issue_type);
					this.resetData();
				});
			}
		}
	},
	methods: {
		save() {
			this.fields.artifact = {
				type: this.artifact.type,
				id: this.artifact.id
			};
			this.fields.issue_type = this.issue_type;
			this.fields.issue_detail = this.issue_detail;
			
			this.submit();
		},
		resetData () {
			this.issue_type = '';
			this.issue_detail = '';
			this.fields = {};
		},
		hide() {
			this.$bvModal.hide('report-issue-modal');
		}
	},
}
</script>